<template>
  <div class="reserve-calendar reserve-achievement">
    <div class="reserve-form">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="searchForm.departmentId"
          :options="departmentList"
          @change="onDepartmentChange"
        />
        <van-dropdown-item
          v-model="searchForm.salesmanId"
          :options="salesList"
          @change="onSalesmanChange"
        />
        <van-dropdown-item
          v-model="searchForm.organizationId"
          :options="hospitalList"
          @change="onHospitalAreaChange"
        />
      </van-dropdown-menu>

    </div>
    <div class="reserve-calendar-main">
      <div class="reserve-calendar-total">
        <p>
          总计{{ totalInfo.total }}人次，收入{{ totalInfo.totalAmount }}元，人均{{ totalInfo.average }}
        </p>
        <p>
          {{ Object.keys(channelInfo).map((key) => {
          return `${key}(${channelInfo[key].total})`;
        }).join("，") }}
        </p>
      </div>
      <van-calendar
        title="预约日程"
        type="single"
        @month-show="showInfo"
        :poppable="false"
        :show-confirm="false"
        :formatter="formatter"
        :max-date="endDate"
        :show-title="false"
      >
        <template #title>
          <div>
            <!-- 预约日程 -->
          </div>
        </template>
        <template #bottom-info="day">
          <div class="reserve-achievement-data">
            <!-- {{ JSON.stringify(day) }} -->
            <div
              v-for="(item, index) in day.dailyInfo"
              :key="index"
            >
              {{ item.channelName }}
              {{ item.total }}
            </div>

          </div>
        </template>

      </van-calendar>
    </div>

  </div>
</template>



<script>
// import { Toast } from "vant";
import moment from "moment";
import hisService from "@/apis/his/index";
import { deepClone } from "@/utils/utils.js";

// 部门简称map
// 保险事业部
// 业务发展部（业发）
// 跨境事业部（跨境）
// 新渠道事业部（新渠道）
// 会员部（会员）
// 东区区域中心（东区）
// 西区区域中心（西区）
// 南区区域中心（南区）
// 北区区域中心（北区）
const departmentNameMap = {
  保险事业部: "保险",
  业务发展部: "业发",
  跨境事业部: "跨境",
  新渠道事业部: "新渠道",
  会员部: "会员",
  东区区域中心: "东区",
  西区区域中心: "西区",
  南区区域中心: "南区",
  北区区域中心: "北区",
};

let originData = [];

export default {
  name: "resinfo",
  data() {
    return {
      totalInfo: {
        total: 0,
        totalAmount: 0,
        // 人均
        average: 0,
      },
      // 渠道统计
      channelInfo: {},
      dailyChannelInfo: {},
      searchForm: {
        departmentId: "",
        salesmanId: "",
        organizationId: "",
      },
      show: true,
      showPopup: false,
      showTypePicker: false,
      demoEvents: [],
      list: [],
      // 部门列表
      departmentList: [],
      // 销售列表
      salesList: [
        {
          text: "销售人员",
          value: "",
        },
      ],
      hospitalList: [
        {
          text: "医疗机构",
          value: "",
        },
        {
          text: "新永门诊部",
          value: "10001",
        },
        {
          text: "新太门诊部",
          value: "10002",
        },
        {
          text: "康复中心",
          value: "10003",
        },
      ],
      levelList: [
        {
          text: "OABC类",
          value: "",
        },
        {
          text: "OAB类",
          value: "1",
        },
        {
          text: "C类",
          value: "2",
        },
      ],
      endDate: new Date(moment().endOf("month").format("YYYY-MM-DD")),
    };
  },
  created() {
    this.getClinicPerformance();
    this.getDeptSalesStructure();
  },
  methods: {
    async getClinicPerformance() {
      const params = {
        msg_type: "OutpatientDepartment.HealthScreen.getClinicPerformance",
        logistics_interface: JSON.stringify({
          year: moment().format("YYYY"),
          month: moment().format("MM"),
        }),
      };

      const res = await hisService.mainMethod(params);
      originData = deepClone(res);
      this.filterData();
    },
    getDeptSalesStructure() {
      const params = {
        msg_type: "OutpatientDepartment.BaesInfoCore.getDeptSalesStructure",
        logistics_interface: "",
      };
      hisService.mainMethod(params).then((res) => {
        res.forEach((item) => {
          item.salesmen = item.salesmen.map((salesman) => {
            return {
              text: salesman.salesmanName,
              value: salesman.salesmanId,
            };
          });
          item.salesmen.unshift({
            text: "销售人员",
            value: "",
          });
          item.text = item.departmentName;
          item.value = item.departmentId;
        });
        res.unshift({
          text: "销售部门",
          value: "",
          salesmen: [
            {
              text: "销售人员",
              value: "",
            },
          ],
        });
        this.departmentList = res;

        console.log(res);
      });
    },

    onVisitTypeConfirm() {},
    formatter(day) {
      const { dailyChannelInfo } = this;
      const date = moment(day.date).format("YYYY-MM-DD");
      let dailyInfo = dailyChannelInfo[date] || [];
      dailyInfo = Object.keys(dailyInfo).map((key) => {
        return {
          channelName: key,
          total: dailyInfo[key],
        };
      });
      // 根据total属性从高到低排序
      dailyInfo.sort((a, b) => b.total - a.total);
      // 数组不足六个元素的用空对象填充
      // dailyInfo = dailyInfo.concat(
      //   Array.from({ length: 5 - dailyInfo.length }, () => {
      //     return {};
      //   })
      // );
      // if (dailyInfo.length % 2 !== 0) {
      //   dailyInfo.push({});
      // }

      day.dailyInfo = dailyInfo;
      return day;
    },
    bingDate() {
      this.showInfo(this.$route.query.date);
    },
    showInfo() {},

    getList(dayKey) {
      for (var i = 0; i < this.demoEvents.length; i++) {
        if (dayKey == this.demoEvents[i].day) {
          return this.demoEvents[i].info;
        }
      }
    },
    // 改进一下filterData方法，如果departmentId有值则以销售人员（salesPersonName）为纬度去统计数据
    // 根据searchForm过滤页面数据
    filterData() {
      const { searchForm } = this;
      let res = deepClone(originData);
      // 定义统计纬度
      let statDimension = "channelName";
      if (!searchForm.departmentId && !searchForm.salesmanId) {
        statDimension = "unitName";
      } else if (searchForm.departmentId && !searchForm.salesmanId) {
        statDimension = "salesPersonName";
      }

      res = res.filter((item) => {
        if (searchForm.departmentId && searchForm.departmentId !== item.unitId)
          return false;
        if (
          searchForm.salesmanId &&
          searchForm.salesmanId !== item.salesPersonId
        )
          return false;
        if (
          searchForm.organizationId &&
          searchForm.organizationId !== item.organizationId
        )
          return false;
        return true;
      });
      let totalInfo = {
        total: 0,
        totalAmount: 0,
        average: 0,
      };

      let channelInfo = {};
      let dailyChannelInfo = {};
      res.forEach((item) => {
        item.channelName = item.channelName.replace("人寿保险有限公司", "");
        item.channelName = item.channelName.replace("有限责任公司", "");
        item.channelName = item.channelName.replace("有限公司", "");
        // channelName取前六个字

        item.channelName = item.channelName.substring(0, 6);
        totalInfo.total += 1;
        totalInfo.totalAmount += item.paymentAmount;

        channelInfo[item[statDimension]] = channelInfo[item[statDimension]] || {
          total: 0,
          totalAmount: 0,
        };
        channelInfo[item[statDimension]].total += 1;
        channelInfo[item[statDimension]].totalAmount += item.paymentAmount;

        dailyChannelInfo[item.paymentDate] =
          dailyChannelInfo[item.paymentDate] || {};
        dailyChannelInfo[item.paymentDate][item[statDimension]] =
          (dailyChannelInfo[item.paymentDate][item[statDimension]] || 0) + 1;
      });

      totalInfo.totalAmount = totalInfo.totalAmount.toFixed(2);
      totalInfo.average =
        totalInfo.total === 0
          ? 0
          : (totalInfo.totalAmount / totalInfo.total).toFixed(2);

      this.totalInfo = totalInfo;
      this.channelInfo = Object.entries(channelInfo)
        .sort(([, a], [, b]) => b.total - a.total)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
      this.dailyChannelInfo = Object.entries(dailyChannelInfo).reduce(
        (acc, [date, channels]) => {
          acc[date] = Object.entries(channels)
            .sort(([, a], [, b]) => b - a)
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
          return acc;
        },
        {}
      );
      // 修改部门名称为departmentNameMap中对应的简写
      this.dailyChannelInfo = Object.entries(this.dailyChannelInfo).reduce(
        (acc, [date, channels]) => {
          acc[date] = Object.entries(channels).reduce((acc, [key, value]) => {
            acc[departmentNameMap[key] || key] = value;
            return acc;
          }, {});
          return acc;
        },
        {}
      );
    },
    onDepartmentChange(value) {
      this.searchForm.departmentId = value;
      // 根据部门id获取销售列表
      const department = this.departmentList.find(
        (item) => item.value === value
      );
      this.salesList = department.salesmen;
      this.searchForm.salesmanId = "";

      this.filterData();
    },
    onSalesmanChange(value) {
      this.searchForm.salesmanId = value;
      this.filterData();
    },
    onHospitalAreaChange(value) {
      this.searchForm.organizationId = value;
      this.filterData();
    },
  },
};
</script>

<style lang="scss">
.reserve-calendar {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .van-calendar {
    height: auto;
  }
  .reserve-calendar-main {
    flex: 1;
    overflow: scroll;
    .reserve-calendar-total {
      padding: 10px;
      background-color: #f5f5f5;
      font-size: 12px;
      p {
        margin: 0;
      }
    }
  }
  .note {
    /* background: url("../../assets/bg1.png") no-repeat; */
    background-position: bottom right;
    padding: 30px;
    text-align: center;
  }
  .van-calendar__day--middle::after {
    border-radius: 50px;
    background-color: red;
  }
  .van-calendar__day--middle {
    color: black;
  }
  .van-calendar__bottom-info {
    font-weight: bold;
    font-size: 16px;
  }
  .van-calendar__day {
  }
  .van-calendar__selected-day {
    background-color: #fff;
    color: black;
    width: 100%;
  }
  .van-calendar__day--before {
    .van-calendar__bottom-info {
      color: #999;
      font-size: 15px;
      font-weight: 300;
    }
  }
  .van-calendar__top-info {
    display: flex;
    justify-content: end;
    padding-right: 10px;

    font-weight: 400;
    font-size: 12px;

    color: rgb(52, 151, 229);
  }

  .van-calendar__day--before {
    .van-calendar__top-info {
      color: #999;
    }
  }
}
.reserve-achievement {
  .van-calendar__day,
  .van-calendar__selected-day {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .van-calendar__bottom-info {
    position: static;
    padding: 0 2px;
    width: 100%;
    box-sizing: border-box;
    height: 100%;
    min-height: 70px;
  }
  .reserve-achievement-data {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1px 1px;
    // background-color: #000;
    font-size: 12px;
    // border: 1px solid #000;
    text-align: left;
    color: #000;
    font-weight: 400;
    div {
      background: #fff;
      word-break: break-all;
      min-height: 20px;
      display: flex;
      align-items: center;
      background: rgb(237, 248, 252);
    }
    div:nth-child(2n) {
      background: rgb(231, 253, 241);
    }
    div:nth-child(3n) {
      background: #fcf6e8;
    }
  }
  .van-calendar__weekday {
    color: #1989fa;
    font-weight: 600;
  }
  .van-calendar__day {
    color: #1989fa;
  }
  .van-calendar__day--disabled {
    color: #c8c9cc;
  }
}
</style>